// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoArrLogoutOutlinedSvg from "@fishx/icons-svg/es/asn/PtoArrLogoutOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoArrLogoutOutlined = function PtoArrLogoutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoArrLogoutOutlinedSvg
  }));
};

PtoArrLogoutOutlined.displayName = 'PtoArrLogoutOutlined';
export default React.forwardRef(PtoArrLogoutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoArrLogoutOutlined.js
// module id = 3867
// module chunks = 0